module.exports = __webpack_public_path__ + "static/media/2.63df9b32.png";